import { SoftTag } from '../../components/Tag/SoftTag';
import { L } from '@lib';

export const LocalizedStatementStatus = {
  Unpaid: L('Unpaid'),
  Paid: L('Paid'),
};

const tagStyle = { minWidth: 100, textAlign: 'center' as const };

export const StatementStatusTag = {
  Unpaid: <SoftTag group="yellow" style={tagStyle}>Unpaid</SoftTag>,
  Paid: <SoftTag group="green" style={tagStyle}>Paid</SoftTag>,
};

export type StatementStatusTagObjectKey = keyof typeof StatementStatusTag;
export type LocalizedStatementStatusObjectKey = keyof typeof LocalizedStatementStatus;
